const state = {
    route: {},
}

const getters = {
    route (state) {
        return state.route
    },
}

const mutations = {
    setRoute (state, route) {
        state.route = route
    },

    clearRoute (state) {
        state.route = {}
    },
}

const actions = {
    setRoute ({ commit }, route) {
        commit('setRoute', route)
    },

    clearRoute ({ commit }) {
        commit('clearRoute')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}